package io.horion.cv.utils

import io.horion.cv.models.ExperienceLevel
import io.horion.cv.models.Job
import io.horion.cv.models.JobStatus
import io.horion.cv.models.JobType
import io.horion.cv.models.SalaryRange

val jobsList = listOf(

    // Job 1 - MTN Cameroun
    Job(
        id = "1",
        enterprise = "MTN Cameroun",
        title = "Développeur Android",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Nous recherchons un développeur Android expérimenté pour rejoindre notre équipe mobile.",
        requirements = listOf(
            "Kotlin",
            "Android Studio",
            "REST API",
            "Git",
            "MVVM",
            "Clean Architecture"
        ),
        responsibilities = listOf(
            "Développer de nouvelles fonctionnalités",
            "Maintenir les applications existantes",
            "Collaborer avec les équipes backend",
            "Participer aux revues de code"
        ),
        salaryRange = SalaryRange(
            min = 800000,
            max = 1500000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-01T08:00:00",
        expire = "2024-05-30T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Mobile", "REST API", "Git", "MVVM"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-01T08:00:00",
        updatedAt = "2024-03-01T08:00:00"
    ),

    // Job 2 - Orange Cameroun
    Job(
        id = "2",
        enterprise = "Orange Cameroun",
        title = "Développeur Backend Kotlin",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Développement des services backend pour les applications clients Orange.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Spring Boot",
            "MongoDB",
            "PostgreSQL",
            "Microservices",
            "Docker",
            "Kubernetes"
        ),
        responsibilities = listOf(
            "Développer des APIs REST",
            "Optimiser les performances",
            "Assurer la sécurité",
            "Maintenir la documentation"
        ),
        salaryRange = SalaryRange(
            min = 900000,
            max = 1600000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-05T09:00:00",
        expire = "2024-06-05T23:59:59",
        contactEmail = "career@orange.cm",
        tags = listOf("Kotlin", "Spring Boot", "Microservices", "MongoDB", "Docker"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-05T09:00:00",
        updatedAt = "2024-03-05T09:00:00"
    ),

    // Job 3 - Jumia Cameroun
    Job(
        id = "3",
        enterprise = "Jumia Cameroun",
        title = "UI/UX Designer",
        city = "Douala, Cameroun",
        type = JobType.CDD,
        description = "Designer créatif pour améliorer l'expérience utilisateur de notre plateforme e-commerce.",
        requirements = listOf(
            "Figma",
            "UX research",
            "Design systems",
            "Adobe XD",
            "Sketch",
            "Prototyping"
        ),
        responsibilities = listOf(
            "Créer des maquettes UI",
            "Améliorer l'expérience utilisateur",
            "Collaborer avec les développeurs",
            "Tester les utilisateurs"
        ),
        salaryRange = SalaryRange(
            min = 600000,
            max = 1000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-02-15T10:00:00",
        expire = "2024-04-15T23:59:59",
        contactEmail = "design@jumia.cm",
        tags = listOf("UI/UX", "Figma", "Design System", "User Research"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-02-15T10:00:00",
        updatedAt = "2024-02-15T10:00:00"
    ),

    // Job 4 - Startup Fintech (Stagiaire)
    Job(
        id = "4",
        enterprise = "Startup Fintech",
        title = "Stagiaire Développeur Web",
        city = "Yaoundé, Cameroun",
        type = JobType.STAGE,
        description = "Stage pour étudiants en informatique sur une plateforme fintech.",
        requirements = listOf(
            "HTML/CSS",
            "JavaScript",
            "Kotlin",
            "React",
            "Vue.js",
            "Git",
            "Team spirit"
        ),
        responsibilities = listOf(
            "Développement frontend",
            "Correction de bugs",
            "Tests fonctionnels",
            "Documentation"
        ),
        salaryRange = SalaryRange(
            min = 100000,
            max = 200000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.JUNIOR,
        publicateAt = "2024-03-10T08:00:00",
        expire = "2024-04-30T23:59:59",
        contactEmail = "rh@fintech-startup.cm",
        tags = listOf("Web", "HTML/CSS", "JavaScript", "Kotlin", "Stage"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-10T08:00:00",
        updatedAt = "2024-03-10T08:00:00"
    ),

    // Job 5 - MTN Cameroun (Deuxième offre)
    Job(
        id = "5",
        enterprise = "MTN Cameroun",
        title = "Développeur Android Senior",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développeur Android senior pour les applications de paiement mobile.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Android SDK",
            "Jetpack Compose",
            "Firebase",
            "Google Play Services",
            "REST API",
            "GraphQL"
        ),
        responsibilities = listOf(
            "Architecture technique",
            "Code review",
            "Mentorat junior",
            "Performance optimization"
        ),
        salaryRange = SalaryRange(
            min = 1000000,
            max = 1800000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.EXPERT,
        publicateAt = "2024-03-20T08:00:00",
        expire = "2024-05-20T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Jetpack Compose", "Firebase", "Expert"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-20T08:00:00",
        updatedAt = "2024-03-20T08:00:00"
    ),

    // Job 6 - Data Scientist
    Job(
        id = "6",
        enterprise = "DataLab Cameroun",
        title = "Data Scientist",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Analyser les données et créer des modèles prédictifs.",
        requirements = listOf(
            "Python",
            "Pandas",
            "NumPy",
            "Scikit-learn",
            "TensorFlow",
            "SQL",
            "Data visualization",
            "Machine learning"
        ),
        responsibilities = listOf(
            "Analyse de données",
            "Modélisation prédictive",
            "Dashboarding",
            "Reporting"
        ),
        salaryRange = SalaryRange(
            min = 1200000,
            max = 2000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-12T10:00:00",
        expire = "2024-06-12T23:59:59",
        contactEmail = "careers@datalab.cm",
        tags = listOf("Python", "Machine Learning", "Data Science", "TensorFlow", "SQL"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-12T10:00:00",
        updatedAt = "2024-03-12T10:00:00"
    ),

    // Job 7 - DevOps Engineer
    Job(
        id = "7",
        enterprise = "CloudSolutions",
        title = "DevOps Engineer",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Gérer l'infrastructure cloud et les pipelines CI/CD.",
        requirements = listOf(
            "AWS",
            "Azure",
            "Docker",
            "Kubernetes",
            "Jenkins",
            "GitLab CI",
            "Terraform",
            "Linux",
            "Python",
            "Bash"
        ),
        responsibilities = listOf(
            "Infrastructure as code",
            "CI/CD pipelines",
            "Monitoring",
            "Security"
        ),
        salaryRange = SalaryRange(
            min = 1300000,
            max = 2100000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-18T09:00:00",
        expire = "2024-06-18T23:59:59",
        contactEmail = "hr@cloudsolutions.cm",
        tags = listOf("AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "DevOps"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-18T09:00:00",
        updatedAt = "2024-03-18T09:00:00"
    ),

    // Job 8 - Frontend Developer
    Job(
        id = "8",
        enterprise = "WebStudio",
        title = "Frontend Developer React",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développement d'interfaces utilisateur modernes et responsives.",
        requirements = listOf(
            "React",
            "TypeScript",
            "Next.js",
            "Tailwind CSS",
            "Redux",
            "GraphQL",
            "Jest",
            "Webpack"
        ),
        responsibilities = listOf(
            "UI development",
            "State management",
            "Performance optimization",
            "Unit testing"
        ),
        salaryRange = SalaryRange(
            min = 700000,
            max = 1300000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-03-22T08:00:00",
        expire = "2024-06-22T23:59:59",
        contactEmail = "jobs@webstudio.cm",
        tags = listOf("React", "TypeScript", "Next.js", "Tailwind", "Frontend"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-22T08:00:00",
        updatedAt = "2024-03-22T08:00:00"
    ),
    Job(
        id = "9",
        enterprise = "MTN Cameroun",
        title = "Développeur Android",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Nous recherchons un développeur Android expérimenté pour rejoindre notre équipe mobile.",
        requirements = listOf(
            "Kotlin",
            "Android Studio",
            "REST API",
            "Git",
            "MVVM",
            "Clean Architecture"
        ),
        responsibilities = listOf(
            "Développer de nouvelles fonctionnalités",
            "Maintenir les applications existantes",
            "Collaborer avec les équipes backend",
            "Participer aux revues de code"
        ),
        salaryRange = SalaryRange(
            min = 800000,
            max = 1500000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-01T08:00:00",
        expire = "2024-05-30T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Mobile", "REST API", "Git", "MVVM"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-01T08:00:00",
        updatedAt = "2024-03-01T08:00:00"
    ),

    // Job 2 - Orange Cameroun
    Job(
        id = "10",
        enterprise = "Orange Cameroun",
        title = "Développeur Backend Kotlin",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Développement des services backend pour les applications clients Orange.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Spring Boot",
            "MongoDB",
            "PostgreSQL",
            "Microservices",
            "Docker",
            "Kubernetes"
        ),
        responsibilities = listOf(
            "Développer des APIs REST",
            "Optimiser les performances",
            "Assurer la sécurité",
            "Maintenir la documentation"
        ),
        salaryRange = SalaryRange(
            min = 900000,
            max = 1600000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-05T09:00:00",
        expire = "2024-06-05T23:59:59",
        contactEmail = "career@orange.cm",
        tags = listOf("Kotlin", "Spring Boot", "Microservices", "MongoDB", "Docker"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-05T09:00:00",
        updatedAt = "2024-03-05T09:00:00"
    ),

    // Job 3 - Jumia Cameroun
    Job(
        id = "11",
        enterprise = "Jumia Cameroun",
        title = "UI/UX Designer",
        city = "Douala, Cameroun",
        type = JobType.CDD,
        description = "Designer créatif pour améliorer l'expérience utilisateur de notre plateforme e-commerce.",
        requirements = listOf(
            "Figma",
            "UX research",
            "Design systems",
            "Adobe XD",
            "Sketch",
            "Prototyping"
        ),
        responsibilities = listOf(
            "Créer des maquettes UI",
            "Améliorer l'expérience utilisateur",
            "Collaborer avec les développeurs",
            "Tester les utilisateurs"
        ),
        salaryRange = SalaryRange(
            min = 600000,
            max = 1000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-02-15T10:00:00",
        expire = "2024-04-15T23:59:59",
        contactEmail = "design@jumia.cm",
        tags = listOf("UI/UX", "Figma", "Design System", "User Research"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-02-15T10:00:00",
        updatedAt = "2024-02-15T10:00:00"
    ),

    // Job 4 - Startup Fintech (Stagiaire)
    Job(
        id = "12",
        enterprise = "Startup Fintech",
        title = "Stagiaire Développeur Web",
        city = "Yaoundé, Cameroun",
        type = JobType.STAGE,
        description = "Stage pour étudiants en informatique sur une plateforme fintech.",
        requirements = listOf(
            "HTML/CSS",
            "JavaScript",
            "Kotlin",
            "React",
            "Vue.js",
            "Git",
            "Team spirit"
        ),
        responsibilities = listOf(
            "Développement frontend",
            "Correction de bugs",
            "Tests fonctionnels",
            "Documentation"
        ),
        salaryRange = SalaryRange(
            min = 100000,
            max = 200000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.JUNIOR,
        publicateAt = "2024-03-10T08:00:00",
        expire = "2024-04-30T23:59:59",
        contactEmail = "rh@fintech-startup.cm",
        tags = listOf("Web", "HTML/CSS", "JavaScript", "Kotlin", "Stage"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-10T08:00:00",
        updatedAt = "2024-03-10T08:00:00"
    ),

    // Job 5 - MTN Cameroun (Deuxième offre)
    Job(
        id = "13",
        enterprise = "MTN Cameroun",
        title = "Développeur Android Senior",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développeur Android senior pour les applications de paiement mobile.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Android SDK",
            "Jetpack Compose",
            "Firebase",
            "Google Play Services",
            "REST API",
            "GraphQL"
        ),
        responsibilities = listOf(
            "Architecture technique",
            "Code review",
            "Mentorat junior",
            "Performance optimization"
        ),
        salaryRange = SalaryRange(
            min = 1000000,
            max = 1800000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.EXPERT,
        publicateAt = "2024-03-20T08:00:00",
        expire = "2024-05-20T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Jetpack Compose", "Firebase", "Expert"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-20T08:00:00",
        updatedAt = "2024-03-20T08:00:00"
    ),

    // Job 6 - Data Scientist
    Job(
        id = "14",
        enterprise = "DataLab Cameroun",
        title = "Data Scientist",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Analyser les données et créer des modèles prédictifs.",
        requirements = listOf(
            "Python",
            "Pandas",
            "NumPy",
            "Scikit-learn",
            "TensorFlow",
            "SQL",
            "Data visualization",
            "Machine learning"
        ),
        responsibilities = listOf(
            "Analyse de données",
            "Modélisation prédictive",
            "Dashboarding",
            "Reporting"
        ),
        salaryRange = SalaryRange(
            min = 1200000,
            max = 2000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-12T10:00:00",
        expire = "2024-06-12T23:59:59",
        contactEmail = "careers@datalab.cm",
        tags = listOf("Python", "Machine Learning", "Data Science", "TensorFlow", "SQL"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-12T10:00:00",
        updatedAt = "2024-03-12T10:00:00"
    ),

    // Job 7 - DevOps Engineer
    Job(
        id = "15",
        enterprise = "CloudSolutions",
        title = "DevOps Engineer",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Gérer l'infrastructure cloud et les pipelines CI/CD.",
        requirements = listOf(
            "AWS",
            "Azure",
            "Docker",
            "Kubernetes",
            "Jenkins",
            "GitLab CI",
            "Terraform",
            "Linux",
            "Python",
            "Bash"
        ),
        responsibilities = listOf(
            "Infrastructure as code",
            "CI/CD pipelines",
            "Monitoring",
            "Security"
        ),
        salaryRange = SalaryRange(
            min = 1300000,
            max = 2100000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-18T09:00:00",
        expire = "2024-06-18T23:59:59",
        contactEmail = "hr@cloudsolutions.cm",
        tags = listOf("AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "DevOps"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-18T09:00:00",
        updatedAt = "2024-03-18T09:00:00"
    ),

    // Job 8 - Frontend Developer
    Job(
        id = "16",
        enterprise = "WebStudio",
        title = "Frontend Developer React",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développement d'interfaces utilisateur modernes et responsives.",
        requirements = listOf(
            "React",
            "TypeScript",
            "Next.js",
            "Tailwind CSS",
            "Redux",
            "GraphQL",
            "Jest",
            "Webpack"
        ),
        responsibilities = listOf(
            "UI development",
            "State management",
            "Performance optimization",
            "Unit testing"
        ),
        salaryRange = SalaryRange(
            min = 700000,
            max = 1300000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-03-22T08:00:00",
        expire = "2024-06-22T23:59:59",
        contactEmail = "jobs@webstudio.cm",
        tags = listOf("React", "TypeScript", "Next.js", "Tailwind", "Frontend"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-22T08:00:00",
        updatedAt = "2024-03-22T08:00:00"
    ),
Job(
        id = "17",
        enterprise = "MTN Cameroun",
        title = "Développeur Android",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Nous recherchons un développeur Android expérimenté pour rejoindre notre équipe mobile.",
        requirements = listOf(
            "Kotlin",
            "Android Studio",
            "REST API",
            "Git",
            "MVVM",
            "Clean Architecture"
        ),
        responsibilities = listOf(
            "Développer de nouvelles fonctionnalités",
            "Maintenir les applications existantes",
            "Collaborer avec les équipes backend",
            "Participer aux revues de code"
        ),
        salaryRange = SalaryRange(
            min = 800000,
            max = 1500000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-01T08:00:00",
        expire = "2024-05-30T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Mobile", "REST API", "Git", "MVVM"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-01T08:00:00",
        updatedAt = "2024-03-01T08:00:00"
    ),

    // Job 2 - Orange Cameroun
    Job(
        id = "19",
        enterprise = "Orange Cameroun",
        title = "Développeur Backend Kotlin",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Développement des services backend pour les applications clients Orange.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Spring Boot",
            "MongoDB",
            "PostgreSQL",
            "Microservices",
            "Docker",
            "Kubernetes"
        ),
        responsibilities = listOf(
            "Développer des APIs REST",
            "Optimiser les performances",
            "Assurer la sécurité",
            "Maintenir la documentation"
        ),
        salaryRange = SalaryRange(
            min = 900000,
            max = 1600000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-05T09:00:00",
        expire = "2024-06-05T23:59:59",
        contactEmail = "career@orange.cm",
        tags = listOf("Kotlin", "Spring Boot", "Microservices", "MongoDB", "Docker"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-05T09:00:00",
        updatedAt = "2024-03-05T09:00:00"
    ),

    // Job 3 - Jumia Cameroun
    Job(
        id = "20",
        enterprise = "Jumia Cameroun",
        title = "UI/UX Designer",
        city = "Douala, Cameroun",
        type = JobType.CDD,
        description = "Designer créatif pour améliorer l'expérience utilisateur de notre plateforme e-commerce.",
        requirements = listOf(
            "Figma",
            "UX research",
            "Design systems",
            "Adobe XD",
            "Sketch",
            "Prototyping"
        ),
        responsibilities = listOf(
            "Créer des maquettes UI",
            "Améliorer l'expérience utilisateur",
            "Collaborer avec les développeurs",
            "Tester les utilisateurs"
        ),
        salaryRange = SalaryRange(
            min = 600000,
            max = 1000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-02-15T10:00:00",
        expire = "2024-04-15T23:59:59",
        contactEmail = "design@jumia.cm",
        tags = listOf("UI/UX", "Figma", "Design System", "User Research"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-02-15T10:00:00",
        updatedAt = "2024-02-15T10:00:00"
    ),

    // Job 4 - Startup Fintech (Stagiaire)
    Job(
        id = "21",
        enterprise = "Startup Fintech",
        title = "Stagiaire Développeur Web",
        city = "Yaoundé, Cameroun",
        type = JobType.STAGE,
        description = "Stage pour étudiants en informatique sur une plateforme fintech.",
        requirements = listOf(
            "HTML/CSS",
            "JavaScript",
            "Kotlin",
            "React",
            "Vue.js",
            "Git",
            "Team spirit"
        ),
        responsibilities = listOf(
            "Développement frontend",
            "Correction de bugs",
            "Tests fonctionnels",
            "Documentation"
        ),
        salaryRange = SalaryRange(
            min = 100000,
            max = 200000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.JUNIOR,
        publicateAt = "2024-03-10T08:00:00",
        expire = "2024-04-30T23:59:59",
        contactEmail = "rh@fintech-startup.cm",
        tags = listOf("Web", "HTML/CSS", "JavaScript", "Kotlin", "Stage"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-10T08:00:00",
        updatedAt = "2024-03-10T08:00:00"
    ),

    // Job 5 - MTN Cameroun (Deuxième offre)
    Job(
        id = "22",
        enterprise = "MTN Cameroun",
        title = "Développeur Android Senior",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développeur Android senior pour les applications de paiement mobile.",
        requirements = listOf(
            "Kotlin",
            "Java",
            "Android SDK",
            "Jetpack Compose",
            "Firebase",
            "Google Play Services",
            "REST API",
            "GraphQL"
        ),
        responsibilities = listOf(
            "Architecture technique",
            "Code review",
            "Mentorat junior",
            "Performance optimization"
        ),
        salaryRange = SalaryRange(
            min = 1000000,
            max = 1800000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.EXPERT,
        publicateAt = "2024-03-20T08:00:00",
        expire = "2024-05-20T23:59:59",
        contactEmail = "recrutement@mtncameroun.com",
        tags = listOf("Android", "Kotlin", "Jetpack Compose", "Firebase", "Expert"),
        isRemote = false,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-20T08:00:00",
        updatedAt = "2024-03-20T08:00:00"
    ),

    // Job 6 - Data Scientist
    Job(
        id = "23",
        enterprise = "DataLab Cameroun",
        title = "Data Scientist",
        city = "Yaoundé, Cameroun",
        type = JobType.CDI,
        description = "Analyser les données et créer des modèles prédictifs.",
        requirements = listOf(
            "Python",
            "Pandas",
            "NumPy",
            "Scikit-learn",
            "TensorFlow",
            "SQL",
            "Data visualization",
            "Machine learning"
        ),
        responsibilities = listOf(
            "Analyse de données",
            "Modélisation prédictive",
            "Dashboarding",
            "Reporting"
        ),
        salaryRange = SalaryRange(
            min = 1200000,
            max = 2000000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-12T10:00:00",
        expire = "2024-06-12T23:59:59",
        contactEmail = "careers@datalab.cm",
        tags = listOf("Python", "Machine Learning", "Data Science", "TensorFlow", "SQL"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-12T10:00:00",
        updatedAt = "2024-03-12T10:00:00"
    ),

    // Job 7 - DevOps Engineer
    Job(
        id = "24",
        enterprise = "CloudSolutions",
        title = "DevOps Engineer",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Gérer l'infrastructure cloud et les pipelines CI/CD.",
        requirements = listOf(
            "AWS",
            "Azure",
            "Docker",
            "Kubernetes",
            "Jenkins",
            "GitLab CI",
            "Terraform",
            "Linux",
            "Python",
            "Bash"
        ),
        responsibilities = listOf(
            "Infrastructure as code",
            "CI/CD pipelines",
            "Monitoring",
            "Security"
        ),
        salaryRange = SalaryRange(
            min = 1300000,
            max = 2100000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.SENIOR,
        publicateAt = "2024-03-18T09:00:00",
        expire = "2024-06-18T23:59:59",
        contactEmail = "hr@cloudsolutions.cm",
        tags = listOf("AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "DevOps"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-18T09:00:00",
        updatedAt = "2024-03-18T09:00:00"
    ),

    // Job 8 - Frontend Developer
    Job(
        id = "25",
        enterprise = "WebStudio",
        title = "Frontend Developer React",
        city = "Douala, Cameroun",
        type = JobType.CDI,
        description = "Développement d'interfaces utilisateur modernes et responsives.",
        requirements = listOf(
            "React",
            "TypeScript",
            "Next.js",
            "Tailwind CSS",
            "Redux",
            "GraphQL",
            "Jest",
            "Webpack"
        ),
        responsibilities = listOf(
            "UI development",
            "State management",
            "Performance optimization",
            "Unit testing"
        ),
        salaryRange = SalaryRange(
            min = 700000,
            max = 1300000,
            currency = "XAF"
        ),
        experience = ExperienceLevel.MID,
        publicateAt = "2024-03-22T08:00:00",
        expire = "2024-06-22T23:59:59",
        contactEmail = "jobs@webstudio.cm",
        tags = listOf("React", "TypeScript", "Next.js", "Tailwind", "Frontend"),
        isRemote = true,
        status = JobStatus.ACTIVE,
        createdAt = "2024-03-22T08:00:00",
        updatedAt = "2024-03-22T08:00:00"
    )
)